import {IAggregatedQuestion, ILevelMapAggregatedTile, ILevelMapTileProgress} from "../../types";
import {parseTileId} from "../../../../shared/utils/parseTileId";
import {fork} from "redux-saga/effects";
import preloadImages from "../preloadImages";

export function* preloadTileImages(questions: Record<number, IAggregatedQuestion>, level: ILevelMapAggregatedTile[][], tiles: ILevelMapTileProgress[]) {
    const imageUrls = tiles
        .flatMap(tile => {
            const {row, column} = parseTileId(tile.id);

            return [
                ...level[row][column].questions,
                ...(level[row + 1] && level[row + 1][column] && level[row + 1][column].questions || []),
                ...(level[row][column + 1] && level[row][column + 1].questions || []),
                ...(level[row - 1] && level[row - 1][column] && level[row - 1][column].questions || []),
                ...(level[row][column - 1] && level[row][column - 1].questions || []),
            ];
        })
        .map(questionId => questions[questionId].imageUrl)
        .filter(function(item, pos, self) {
            return self.indexOf(item) === pos;
        });

    yield fork(preloadImages, imageUrls);
}